import React from 'react'
import PropTypes from 'prop-types'

import Breadcrumbs from './../block/Breadcrumbs'
import Kontakti from './../block/Kontakti'

import StormcloudButton from './../block/StormcloudButton'

import { Container, Image, Button } from 'react-bootstrap'

import styles from './../style/Produkciya.module.scss'

class Produkciya extends React.Component {

  render() {

    const { data, protocol, assets_path } = this.props

    return (
      <>
        <Breadcrumbs items={data?.breadcrumbs || []} />
        <div className={styles.section}>
          <Container>
            <div className={styles.items}>
              {data?.produkciya_page.map( ( elm, k ) => (
                <div className={styles.elm}>
                  <Image className={styles.elm_image} src={elm?.image} width={287} height={150} alt={elm?.name} />
                  <div className={styles.elm_content}>
                    <Button
                      className={`${styles.button} stretched-link`}
                      href={elm?.href}
                      variant='primary'
                      onClick={() => {}}
                    >
                      <div className={styles.button_icon}>
                        <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1.09082 7.90998L7.909 1.0918M7.909 1.0918H2.45446M7.909 1.0918V6.54634" strokeLinecap="round"/>
                        </svg>
                      </div>
                      <div className={styles.button_text}>Подробнее</div>
                    </Button>
                    <div className={styles.elm_name}>{elm?.name}</div>
                  </div>
                </div>
              ))}
              <div className={styles.elm_last}>
                <div className={styles.elm_last_name}>Мы — есть в ВКонтакте</div>
                <div className={styles.elm_last_text}>Будь в курсе всего самого важного и интересного первым</div>
                <a target="_blank" style={{ textDecoration: `none` }} href={data?.vklink}>
                  <StormcloudButton
                    text={`Перейти в сообщество ВК`}
                    svg={(
                      <Image src={`/${assets_path}/images/vk.svg`} alt="VK" width={15} height={15} />
                    )}
                    width={247}
                  />
                </a>
              </div>
            </div>
          </Container>
        </div>
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
        />
      </>
    )
  }
}

Produkciya.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

Produkciya.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default Produkciya